import { get } from 'lodash';
import {
	ACCOUNT_CAPABILITIES,
	BACS_CREDIT_CODE,
	BACS_DEBIT_CODE,
	TYPE_BACS_CREDIT,
	TYPE_BACS_DEBIT,
} from '../../config';
import { filterSelected, formatFavourites } from '../../utils/accountUtils';
import { getPaymentType } from '../modes/selectors';
import { getSelectedFromAccount } from '../payeeSelector/selectors';

export const getFavouriteAccounts = (state) =>
	filterSelected(get(state, 'accountPaging.favourites.accounts', []), [getSelectedFromAccount(state)]);

export const getFavouriteAccountsForPicker = (state) => {
	const paymentType = getPaymentType(state);

	const paymentTypeFilter = (paymentType, favouriteAccount) => {
		const getPaymentTypeFavourite = favouriteAccount.actionsAvailable[paymentType];
		const bacsIds = favouriteAccount.bacs;
		const hasBacsIds = bacsIds && bacsIds.length;

		if (paymentType === ACCOUNT_CAPABILITIES[TYPE_BACS_CREDIT]) {
			return getPaymentTypeFavourite && hasBacsIds && bacsIds.some((bacsId) => bacsId.type === BACS_CREDIT_CODE);
		} else if (paymentType === ACCOUNT_CAPABILITIES[TYPE_BACS_DEBIT]) {
			return getPaymentTypeFavourite && hasBacsIds && bacsIds.some((bacsId) => bacsId.type === BACS_DEBIT_CODE);
		} else {
			return getPaymentTypeFavourite;
		}
	};

	const allFavouriteAccounts = formatFavourites(getFavouriteAccounts(state));

	if (paymentType) {
		const paymentCapability = ACCOUNT_CAPABILITIES[paymentType];
		const paymentTypes = paymentCapability.split(',');
		return allFavouriteAccounts.filter((favouriteAccount) =>
			paymentTypes.some((paymentType) => paymentTypeFilter(paymentType, favouriteAccount))
		);
	}
	return allFavouriteAccounts;
};
